var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.88,39.166c3.837,0,6.958-3.122,6.958-6.958s-3.121-6.958-6.958-6.958s-6.958,3.122-6.958,6.958 S57.043,39.166,60.88,39.166z M60.88,29.25c1.631,0,2.958,1.327,2.958,2.958s-1.327,2.958-2.958,2.958s-2.958-1.327-2.958-2.958 S59.249,29.25,60.88,29.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.171,67.75L59.2,47.017c-0.357-0.619-1.018-1-1.732-1s-1.375,0.381-1.732,1l-4.195,7.268l-3.555-6.157 c-0.014-0.026-0.029-0.052-0.044-0.078l-4.137-7.165c-0.357-0.619-1.018-1-1.732-1s-1.375,0.381-1.732,1l-4.673,8.093 c-0.007,0.012-0.014,0.023-0.02,0.035L24.83,67.75c-0.552,0.957-0.225,2.18,0.732,2.732c0.956,0.552,2.181,0.224,2.732-0.732 l8.924-15.457l0.896,1.884c0.278,0.585,0.822,0.998,1.46,1.11c0.639,0.115,1.291-0.091,1.751-0.547l4.467-4.41l4.015,6.955 c0.357,0.619,1.018,1,1.732,1s1.375-0.381,1.732-1l4.195-7.268L67.706,69.75c0.371,0.642,1.043,1,1.734,1 c0.339,0,0.684-0.086,0.998-0.268C71.396,69.93,71.723,68.707,71.171,67.75z M40.517,51.918l-0.871-1.83l2.426-4.202l1.654,2.864 L40.517,51.918z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.f2f57d3ae4b89ae418daeadef6bc3fef.svg";
export { ForwardRef as ReactComponent };